export type ProjectDataType = {
  projectId: string;
  projectName: string;
  projectLocation: string;
  projectPhaseId: number;
  projectPhaseName: string;
  projectType: string;
};

/**
 * Retrieves the current project data from local storage with camel cased keys.
 * Project data must exist in `mage-cache-storage`.
 *
 * @returns {ProjectDataType | null} - An object containing project details (e.g., ID, name, location, phase, type),
 * or `null` if no relevant data is found in local storage.
 */
export const getCurrentProjectData = (): ProjectDataType | null => {
  const localStorageData = localStorage.getItem('mage-cache-storage');
  if (localStorageData) {
    const localStorageObject = JSON.parse(localStorageData);
    const customerData = localStorageObject.customer;
    return {
      projectId: customerData.current_project,
      projectLocation: customerData.current_project_location,
      projectName: customerData.current_project_name,
      projectPhaseId: customerData.current_project_phase_id,
      projectPhaseName: customerData.current_project_phase_name,
      projectType: customerData.current_project_type,
    };
  }
  return null;
};
